export enum FilterType {
  textBox,
  number,
  dropdown,
  autocomplete,
  date,
  boolean
}
